import { render, staticRenderFns } from "./StampObject.vue?vue&type=template&id=417ce424&scoped=true&"
import script from "./StampObject.vue?vue&type=script&lang=ts&"
export * from "./StampObject.vue?vue&type=script&lang=ts&"
import style0 from "./StampObject.vue?vue&type=style&index=0&id=417ce424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ce424",
  null
  
)

export default component.exports